import Manager from './manager';
import Franchise from './franchise';

export default {
  Manager,
  Franchise,
};
